

import { PackageDetailController } from "./controllers/packageDetailController";


export class PackageDetailDirective implements angular.IDirective {
    template = require('./templates/packageDetail.html');
    restrict = 'E';
    controller = PackageDetailController;
    controllerAs = 'vm';
    bindToController = {
        requestPackages: '=requestPackages'
    };
    scope = {};

    static factory(): angular.IDirectiveFactory {
        return () => new PackageDetailDirective();
    }
}

angular.module('deliveryCreate.app').directive("packageDetail", PackageDetailDirective.factory());



/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/request/requestDetail/directives/packageDetail/packageDetailDirective.ts
 **/